<route lang="yaml">
meta:
    layout: 'api-layout'
    requires_auth: false
    hide_for_logged_in: false
</route>

<script setup
        lang="ts">
import { ref }          from 'vue';
import { useHead }      from '@reshepe/hooks';
import { ApiReference } from '@scalar/api-reference';

const url = ref<string>(import.meta.env.VITE_AFFILIATE_OPENAPI_URL);

useHead({
    title: 'affiliate api reference',
});
</script>

<template>
    <ApiReference :configuration="{
        darkMode: true,
        hideModels: true,
        hideDownloadButton: true,
        showSidebar: true,
        searchHotKey: 'k',
        url,
    }" />
</template>
